import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

const KEY = "twe_age_confirmed";

export const AgeGate = () => {
  const { pathname } = useLocation();
  const [ok, setOk] = useState(() => localStorage.getItem(KEY) === "yes");
  const [under, setUnder] = useState(() => localStorage.getItem(KEY) === "no");
  if (ok || pathname === "/terms") return null;

  return (
    <div className="fixed inset-0 z-[100] bg-[#0B101D]/95 backdrop-blur-xl grid place-items-center p-4" data-testid="age-gate">
      <div className="w-full max-w-md rounded-3xl bg-[#131C31] border border-blue-500/30 p-8 text-center shadow-[0_0_60px_rgba(37,99,235,0.25)] rise">
        <img src="/logo-horse.png" alt="The Weekend Edge" className="h-16 mx-auto rounded-lg mb-5" />
        {!under ? (
          <>
            <h1 className="font-display text-2xl font-black uppercase tracking-tight mb-2">Are you 18 or over?</h1>
            <p className="text-sm text-slate-400 mb-6">The Weekend Edge publishes racing tips and is only for adults. Please confirm your age to continue.</p>
            <div className="flex flex-col gap-3">
              <button data-testid="age-gate-confirm" onClick={() => { localStorage.setItem(KEY, "yes"); setOk(true); }}
                className="w-full py-3 rounded-full bg-blue-600 hover:bg-blue-500 font-semibold transition-colors">I'm 18 or over</button>
              <button data-testid="age-gate-under" onClick={() => { localStorage.setItem(KEY, "no"); setUnder(true); }}
                className="w-full py-3 rounded-full border border-white/10 text-slate-300 hover:bg-white/5 transition-colors">I'm under 18</button>
            </div>
            <p className="text-xs text-slate-500 mt-5">By continuing you agree to our <Link to="/terms" className="underline" data-testid="age-gate-terms-link">Terms & Conditions</Link>.</p>
          </>
        ) : (
          <div data-testid="age-gate-blocked">
            <ShieldAlert className="w-10 h-10 text-amber-400 mx-auto mb-3" />
            <h1 className="font-display text-2xl font-black uppercase tracking-tight mb-2">Sorry, adults only</h1>
            <p className="text-sm text-slate-400">You must be 18 or older to use The Weekend Edge.</p>
            <p className="text-sm text-slate-400 mt-4">Worried about gambling? Visit <a className="text-blue-400 underline" href="https://www.gamblinghelponline.org.au" target="_blank" rel="noopener noreferrer">gamblinghelponline.org.au</a> or call <a className="text-blue-400" href="tel:1800858858">1800 858 858</a>.</p>
          </div>
        )}
      </div>
    </div>
  );
};
